import React, { useRef } from "react";
import RecipeArrow from "../../../../assets/svg/components/RecipeArrow.svg";

export const IndustryRecipe = React.forwardRef(
  ({ title, type, url, description, ctaText }, ref) => {
    const linkRef = useRef();
    return (
      <article
        ref={ref}
        className="industry_recipe_article"
        aria-hidden="true"
        onClick={() => linkRef.current.click()}
      >
        <div className="industry_recipe_article-pill">{type}</div>
        <h3>{title}</h3>
        <p>{description}</p>
        <a href={url} ref={linkRef}>
          {ctaText} <img src={RecipeArrow.src} alt="" width="16" height="16" loading="lazy" />
        </a>
      </article>
    );
  },
);
